export const mapLocalNavigation = ({ content, settings }): Content.ContentModule => ({
	documentType: content?.contentType,
	content: {
		properties: {
			kicker: content.properties.kicker,
			heading: content.properties.heading,
			text: content.properties.text?.markup ?? null,
		},
	},
	settings: {
		properties: settings?.properties ?? null,
	},
});
